
// Change log
// theme.js — Lines 1003–1019 added inside Filter class constructor

var base;

function adjustViewPortHeight() {
	// Get the viewport height in pixels
	const viewportHeight = window.innerHeight;
	console.log(viewportHeight);
	// Set a CSS variable (--vh) to 1% of the viewport height
	root.style.setProperty('--vh', `${viewportHeight * 0.01}px`);
}

function get_scroll_position(){
  scroll_top=window.scrollY;
  scroll_bottom=scroll_top+window_height;
  scroll_mid=scroll_top+(.8*window_height);
}

function testCart(e){
	var el=e.target;
	console.log(e.target);
	var dialog=document.querySelectorAll('.cart-drawer__dialog')[0];
	if(e.target===root) console.log('body?');
	if(e.target===root && dialog.hasAttribute('open')) {
		console.log('here?');
		dialog.querySelectorAll('.button.close-button')[0].click();
	}
}

function configure_window(){

  window_height=window.innerHeight;
  if(document.querySelectorAll('#toolbar-bar').length){
	admin_offset=document.querySelectorAll('#toolbar-bar')[0].offsetHeight+document.querySelectorAll('.toolbar-menu-administration')[0].offsetHeight;
	root.style.setProperty('--admin-offset', admin_offset+'px');
  }
  get_scroll_position();
}

var root=document.documentElement;
var body=document.querySelectorAll('body')[0];
var window_height=0;
var admin_offset=0;

var scroll_top=0;
var scroll_bottom=0;
var scroll_mid=0;

configure_window();
adjustViewPortHeight();

document.addEventListener('click', (e)=>{
	testCart(e);
})

document.addEventListener("DOMContentLoaded", function(event) {
	
	document.querySelectorAll('#insta-feed').forEach((el)=>{
	 el.carousel=new CarouselInstagram(el);
	 console.log('testing this?')
	});
	
	document.querySelectorAll('zoom-dialog').forEach((el)=>{
		el.zoom=new Zoom(el);
	})
	
	var el=document.querySelectorAll('[data-template*="product"] .product-information');
	el.forEach((el)=>{
		console.log('app tabs?')
		new AppTabs(el)
	});
	
	document.querySelectorAll('[data-size-chart]').forEach((el)=>{
		el.addEventListener('click', (e)=>{
			e.preventDefault();
			var el=e.target;
			var url=window.location.origin+''+el.getAttribute('data-href');
			fetch(url) // Send a GET request to the specified URL
				.then(response => {
					return response.text()
				})
				.then(htmlContent => {
					const parser=new DOMParser()
					const doc=parser.parseFromString(htmlContent, "text/html");					
					const main = doc.querySelectorAll('#MainContent')[0];
					document.querySelectorAll('#size-chart-modal .predictive-search-form__content')[0].innerHTML=main.innerHTML;
				})
				.catch(error => {
					console.error('There has been a problem with your fetch operation:', error);
				});
		})
	})
	
	document.addEventListener("scroll", (event) => {
		get_scroll_position();
	})
	
	let listArr=[];
	
	var div=document.querySelectorAll('.work--block .grid > div');
	div.forEach((div)=>{
		var span=div.querySelectorAll('.char-wrapper');
		span.forEach((el, index)=>{
			el.setAttribute('data-index', index);
		})
	})
	
	var swiper=document.querySelectorAll('.swiper');
	swiper.forEach((el)=>{
		
		var isFeatured=el.closest('.featured-collection')
		var cnt=isFeatured ? 1 : 2
		
		el.swiper=new Swiper(el, {
			slidesPerView: cnt,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				type: "fraction",
		  	},
			breakpoints: {
				600: {
					slidesPerView: 4
				}
			}
		})
	})
	var collection=document.querySelectorAll('[data-template="collection"]');
	if(collection.length) new Filter();
	
	document.querySelectorAll('.instagram-feed').forEach((el)=>{
	 el.carousel=new CarouselInstagram(el);
	});
	
	document.querySelectorAll('.drop--down').forEach((el)=>{
		el.dropdown=new DropDown(el);
	})
	var tabArr=[];
	document.querySelectorAll('.accordion--tablist').forEach((el)=>{
		tabArr.push(new TabList(el));
	});
	document.querySelectorAll('media-gallery').forEach((el)=>{
		el.thumb=new ThumbNav(el);
	})
	runImg();
	document.addEventListener("rerunImages", function(){ 
		setTimeout(function(){ runImg(); }, 250);
		document.querySelectorAll('media-gallery').forEach((el)=>{
			el.thumb=new ThumbNav(el);
		})
	});
	var coll=document.querySelectorAll('[data-template="collection"]')
	if(coll.length){
		new CollectionNav();
	}
	
	var whatIG=document.querySelectorAll('.shopify-section-group-footer-group .whatmore-base');
	whatIG.forEach((el)=>{
		el.what=new WhatMoreInstagram(el);	
	})
	
	document.querySelectorAll('.account-drawer__close-button').forEach((el)=>{
		el.addEventListener('click', function(e){
			e.preventDefault();
			window.dispatchEvent(new Event('resize'));
		})
	})
	
	new MobileNav();
	new Visibility();
	new Dark();
}); 

function runImg() {
	
	document.querySelectorAll('.banner img, .product-media__image:not([data-init]').forEach((el)=>{
		if(el.complete){
			el.setAttribute('data-init', 1);
		}else {
			el.addEventListener('load', (e)=>{
				e.target.setAttribute('data-init', 1);
			})
		}
	})
}

class Zoom {
	constructor(el) {
		var __this=this;
		this.el=el;
		this.timer=null;
		this.dialog=this.el.querySelectorAll('dialog')[0];
		this.btn=this.el.querySelectorAll('.nav--zoom a');
		this.li=this.el.querySelectorAll('li');
		this.thumb=this.el.closest('media-gallery').querySelectorAll('.media-gallery__grid li');
		this.index=0;
		this.runClick();
		this.btn.forEach(el=>{
			el.addEventListener('click', function(e){
				e.preventDefault();
				__this.initClick(e.target);
			})
		})
		this.thumb.forEach((el, index)=>{
			el.index=index;
			el.zoom=new ZoomBtn(__this, el, index);
		})
		this.li.forEach((el)=>{
			el.zoomzoom=new ZoomZoom(el);
		})
		this.close=this.el.querySelectorAll('button[aria-label="close"]')[0];
		this.close.addEventListener('click', function(){
			__this.hideModal();
		})
		
	}
	initClick(el){
		var type=el.getAttribute('href');
		if(type=='#next') this.index++;
		else this.index--
		this.index=this.index<0 ? this.li.length-1 : this.index;
		this.index=this.index>=this.li.length ? 0 : this.index;
		this.runClick();
	}
	hideModal(){
		var __this=this;
		this.li.forEach(el=>{
			el.classList.remove('active')
			el.classList.remove('zoom')
		})
		this.dialog.classList.remove('active');
		this.timer=setTimeout(function(){ __this.dialog.close(); }, 2500);
	}
	runUpdate(index){
		clearTimeout(this.timer);
		this.dialog.showModal();
		this.dialog.offsetHeight;
		this.dialog.classList.add('active');
		this.index=index;
		this.runClick();
	}
	runClick(){
		this.li.forEach(el=>{
			el.classList.remove('active')
			el.classList.remove('zoom')
		})
		var intEl=this.li[this.index];
		intEl.classList.add('active');
		var intHeight=intEl.offsetHeight;
		/*
			if (typeof intHeight=='undefined') return
			intEl.parentElement.style.height=intEl.offsetHeight;
		*/
	}
}

class ZoomBtn {
	constructor(root, el, index) {
		var __this=this;
		this.root=root;
		this.index=index;
		this.el=el;
		this.el.addEventListener('click', function(){
			__this.root.runUpdate(__this.index);
		})
	}
}

class ZoomZoom {
	
	constructor(el){
		var __this=this;
		this.el=el;
		this.el.addEventListener('click', function(e){
			__this.runClick(e)
		})
	}
	runClick(e) {
		if(this.el.classList.contains('zoom')) this.el.classList.remove('zoom');
		else this.initClick(e)
	}
	initClick(e){
		var x=e.pageX*100/window.innerWidth;
		var y=e.pageY*100/window.innerHeight;
		this.el.classList.add('zoom');
		this.el.style.setProperty('--zoom-focal', x+'% '+y+'%');
	}
}

class AppTabs {
	
	constructor(el){
		var __this=this;
		this.el=el;
		this.init();
		this.whatmore=new WhatMore(this, this.el);
		this.tolstoy=new TolStoy(this, this.el);
		
	}
	init(){
		var __this=this;
		var pos=this.el.querySelectorAll('.whatmore-base');
		console.log(pos.length);
		if(!pos.length) return;
		this.posEl=pos[0].closest('.group-block-content');
		this.container=this.posEl;
		this.container.classList.add('container--app')
		this.div=document.createElement('DIV');
		this.div.classList.add('tablist');
		this.div.classList.add('tablist--apps')
		this.div.innerHTML='<div class="tablist--header"><a href="#wear" data-index="0">How We Wear It</a><a href="#sizing" data-index="1">How Our Sizing Works</a></div>';
		this.posEl.prepend(this.div);
		this.tab=this.container.querySelectorAll('.tablist a');
		this.app=this.container.querySelectorAll('.shopify-app-block');
		this.tab.forEach((el)=>{
			el.addEventListener('click', (e)=>{
				e.preventDefault();
				__this.runClick(e.target);
			})
		})
	}
	initEl(mode){
		this.div.setAttribute('data-init', '');
		if(mode=='whatmore') {
			this.tab[0].setAttribute('data-init', 1);
		}else {
			this.tab[1].setAttribute('data-init', 1);
		}
		var first=this.container.querySelectorAll('.tablist a[data-init]');
		if(first.length) this.runClick(first[0]);
	}
	runClick(el){
		this.tab.forEach((el)=>{
			el.classList.remove('active');
		})
		this.app.forEach((el)=>{
			el.classList.remove('active');
		})
		var index=el.getAttribute('data-index');
		el.classList.add('active');
		this.app[index].classList.add('active');
	}
}

class WhatMore {
	
	constructor(root, el) {
		var __this=this;
		this.root=root;
		this.el=el;
		this.what;
		this.cnt=10;
		this.curr=0;
		this.wait=2000;
		this.init=0;
		this.imgInit=0;
		window.addEventListener('scroll', function(){ __this.checkLoad(); })
		this.checkLoad();
	}
	checkLoad(){
		var __this=this;
		if(this.init) return;
		var el=this.el.querySelectorAll('.whatmore-carousel-horizontal-flex video');
		if(el.length) {
			this.init=1;
			this.runInit();
		}
	}
	runInit(){
		var __this=this;
		this.tile=this.el.querySelectorAll('.whatmore-carousel-horizontal-flex > div');
		this.inner=this.tile[0].parentNode;
		this.container=this.inner.parentNode;
		this.super=this.container.closest('.shopify-block');
		setTimeout(function(){ __this.carouselInit(); }, 1000);
	}
	carouselInit(){
		var __this=this;
		
		this.tile.forEach((el)=>{
			el.classList.add('swiper-slide')
		})
		
		this.container.classList.add('swiper');
		this.container.classList.add('swiper--app');
		this.inner.classList.add('swiper-wrapper');
		var div=document.createElement('DIV');
		div.innerHTML=swiperNav();
		this.container.append(div);
		
		this.swiper=new Swiper(this.container, {
			slidesPerView: 3,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				type: "fraction",
			  },
		})
		var root=this.container.closest('.whatmore-root');
		root.classList.remove('whatmore-root');
		this.container.offsetHeight;
		this.container.setAttribute('data-init', 1);
		this.root.initEl('whatmore');
	}
}

class WhatMoreInstagram {
		
	constructor(el) {
		var __this=this;
		this.root=root;
		this.el=el;
		this.what;
		this.cnt=10;
		this.curr=0;
		this.init=0;
		this.swiperInit=0;
		this.swiper=null;
		this.imgInit=0;
		this.slideTimer=null;
		this.observer = new MutationObserver(() => {
			__this.checkLoad();
		});
		this.observer.observe(this.el, {
		  subtree: true,
		  childList: true,
		});
		window.addEventListener('resize', function(){ __this.carouselInit(); })
	}
	checkLoad(){
		var __this=this;
		var slides=this.el.querySelectorAll('.swiper-slide:not([data-init]');
		if(slides.length) {
			if(!this.init) this.runInit();
			this.initSlides(slides);
			//setTimeout(function(){ __this.el.querySelectorAll('.swiper-button-next')[0].click(); }, 50);
		}
		
	}
	initSlides(slides){
		var __this=this;
		slides.forEach(el=>{
			el.setAttribute('data-init', '');
			el.ig=new WhatMoreSlide(this, el);
		})
	}
	runInit(){
		var __this=this;
		this.init=1;
		var div=document.createElement('DIV');
		div.classList.add('overflow--hidden');
		div.innerHTML='<div class="carousel-ig data-visibility"><div class="carousel-ig--box"></div><div class="carousel-ig--box"></div><div class="carousel-ig--box"></div></div>';
		var section=this.el.closest('.shopify-section');
		section.after(div);
		this.swiperContainer=div.querySelectorAll('.carousel-ig')[0];
		this.swiperInner=this.swiperContainer.querySelectorAll('.carousel-ig--box');
	}
	carouselInit(){
		var __this=this;
		this.init=1;
		var slide=this.swiperInner[0].querySelectorAll('.carousel-ig--item');
		var width=slide[0].offsetWidth*slide.length;
		this.swiperContainer.style.width=width+'px';
		if(this.slideTimer==null) this.sliderTimer=setTimeout(function(){ __this.runSlide(); }, 50 );
	}
	updateCarousel(div, clickDiv){
		var slides=this.swiperInner[0].querySelectorAll('.carousel-ig--item');
		if(slides.length>4) return;
		this.swiperInner.forEach((el)=>{
			var divClone=div.cloneNode();
			divClone.innerHTML=div.innerHTML;
			el.append(divClone);
			divClone.addEventListener('click', function(){
				clickDiv.click();
			})
		})
		
		//div.destroy();
		this.carouselInit();
	}
	runSlide(){
		var __this=this;
		var cnt=this.swiperInner[0].querySelectorAll('.carousel-ig--item').length;
		var rnd=Math.floor(Math.random()*cnt);
		
		this.swiperInner.forEach((el)=>{
			var item=el.querySelectorAll('.carousel-ig--item');
			item.forEach((int)=>{
				int.classList.remove('active');
				int.querySelectorAll('video')[0].pause();
			})
		})
		this.swiperInner.forEach((el)=>{
			var item=el.querySelectorAll('.carousel-ig--item')[rnd];
			item.classList.add('active')
			item.querySelectorAll('video')[0].play();
		})
		
		this.sliderTimer=setTimeout(function(){ __this.runSlide(); }, 3500 );
	}
}

class WhatMoreSlide {
	
	constructor(root, el) {
		var __this=this;
		this.root=root;
		this.el=el;
		this.observer = new MutationObserver(() => {
			__this.checkLoad();
		});
		this.observer.observe(this.el, {
		  subtree: true,
		  childList: true,
		});
	}
	checkLoad(){
		var video=this.el.querySelectorAll('source')
		if(!video.length) return;
		if(video.length) this.runInit();
	}
	runInit(){
		var __this=this;
		this.slide=document.createElement('div');
		this.slide.classList.add('carousel-ig--item');
		var video=this.el.querySelectorAll('video')[0];
		var poster=video.getAttribute('poster');
		video.pause();
		//video.remove();
		
		var videoClone=document.createElement('video');
		
		//videoClone.setAttribute('autoplay', '');
		videoClone.setAttribute('muted', '');
		videoClone.setAttribute('loop', '');
		//videoClone.setAttribute('playsinline', '');
		videoClone.setAttribute('poster', poster);
		videoClone.innerHTML=video.innerHTML;
		videoClone.pause();
		
		var imgClone=document.createElement('img');
		imgClone.setAttribute('src', poster);
		
		this.slide.append(videoClone);
		this.slide.append(imgClone);
		
		this.root.updateCarousel(this.slide, __this.el.querySelectorAll('div')[0]);
		
	}
}


class TolStoy {
	
	constructor(root, el) {
		var __this=this;
		this.root=root;
		this.el=el;
		this.what;
		this.cnt=10;
		this.curr=0;
		this.wait=2000;
		this.init=0;
		this.imgInit=0;
		window.addEventListener('scroll', function(){ __this.checkLoad(); })
		this.checkLoad();
	}
	checkLoad(){
		var __this=this;
		if(this.init) return;
		var el=this.el.querySelectorAll('.tolstoy-stories-tile');
		if(el.length) {
			this.init=1;
			this.inner=el[0].parentNode;
			this.container=this.inner.parentNode;
			this.runInit();
		}
	}
	runInit(){
		var __this=this;
		
		var tile=this.inner.querySelectorAll('.tolstoy-stories-tile');
		tile.forEach((el)=>{
			el.classList.add('swiper-slide')
		})
		this.carouselInit();
	}
	carouselInit(){
		var __this=this;
		this.container.classList.add('swiper');
		this.container.classList.add('swiper--app');
		this.inner.classList.add('swiper-wrapper');
		this.container.innerHTML=this.container.innerHTML+swiperNav();
		
		this.swiper=new Swiper(this.container, {
			slidesPerView: 3, 
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				type: "fraction",
			  },
		})
		this.container.offsetHeight;
		this.container.setAttribute('data-init', 1);
		this.root.initEl('tolstoy');
	}
}

function swiperNav(){
	return '<div class="swiper--nav"><a href="#" class="swiper-button-prev" tabindex="0" role="button" aria-label="Previous slide" aria-controls="swiper-wrapper-a6f246e128b5b3da" aria-disabled="false"><span class="svg-wrapper svg-wrapper--small"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve"><style type="text/css">.st0{fill:none;stroke:#000000;stroke-width:2.4367;stroke-miterlimit:10;}</style><polyline class="st0" points="4.9,19.7 30.2,45 55.1,19.7 "></polyline></svg></span></a><a href="#" class="swiper-button-next" tabindex="0" role="button" aria-label="Next slide" aria-controls="swiper-wrapper-a6f246e128b5b3da" aria-disabled="false"><span class="svg-wrapper svg-wrapper--small"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve"><style type="text/css">.st0{fill:none;stroke:#000000;stroke-width:2.4367;stroke-miterlimit:10;}</style><polyline class="st0" points="4.9,19.7 30.2,45 55.1,19.7 "></polyline></svg></span></a><div>( <span class="swiper-pagination swiper-pagination-fraction swiper-pagination-horizontal"></span> )</div></div>';
}

class MobileNav {
	
	constructor(){
		var __this=this;
		this.el=document.querySelectorAll('.menu-drawer__navigation');
		this.ul=document.querySelectorAll('.menu-drawer__navigation ul')[0];
		this.a=document.querySelectorAll('.menu-drawer__list-item--flat');
		this.cont=document.querySelectorAll('.mobile-nav--secondary')[0];
		this.init=0;
		this.setupChildren();
		document.addEventListener("rerunImages", function(){ __this.setupBack(); })
	}
	setupChildren(){
		var __this=this;
		var aArr=[];
		this.a.forEach((el)=>{
			var child=el.querySelectorAll('ul');
			if(child.length){
				//__this.initChild(el, child[0]);
				aArr.push(new MobileNavItem(__this, el, child[0]));
			}
		})
	}
	setupBack(){
		var __this=this;
		this.bak=this.cont.querySelectorAll('.secondary--back')[0];
		var wrap=this.bak.querySelectorAll('.svg-wrapper');
		if(!wrap.length) this.bak.innerHTML=this.bak.innerHTML+'<span class="svg-wrapper svg-wrapper--small rotate-left">'+iconCarat()+'</span>';
		this.bak.addEventListener('click', (e)=>{
			e.preventDefault();
			body.removeAttribute('data-secondary');
			__this.cont.querySelectorAll('ul').forEach((el)=>{
				el.classList.remove('active');
			})
			this.ul.style.height='auto';
		})
	}
	setHeight(val) {
		this.ul.style.height=val+'px';
	}
}

class MobileNavItem {
	
	constructor(root, el, ul) {
		var __this=this;
		this.root=root;
		this.init=0;
		this.el=el;
		this.a=this.el.querySelectorAll('a')[0];
		this.ul=ul;
		this.cont=document.querySelectorAll('.mobile-nav--secondary')[0];
		document.addEventListener("rerunImages", function(){ 
			__this.initItem();
		})
	}
	initItem(){
		var __this=this;
		this.cont.append(this.ul);
		var wrap=this.a.querySelectorAll('.svg-wrapper');
		if(!wrap.length) this.a.innerHTML=this.a.innerHTML+'<span class="svg-wrapper svg-wrapper--small rotate-right">'+iconCarat()+'</span>';
		this.a.addEventListener('click', (e)=>{
			e.preventDefault();
			__this.ul.classList.add('active');
			__this.ul.offsetHeight;
			var ulHeight=__this.ul.offsetHeight+34;
			console.log(ulHeight);
			__this.root.setHeight(ulHeight);
			
			body.setAttribute('data-secondary', 1);
		})
	}
}

class CollectionNav {
	
	constructor(){
		var __this=this;
		this.container=document.getElementById('ResultsList');
		this.term='model';
		this.altTerm='product';
		this.setupBlocks();
		this.mode='product';
		document.addEventListener("rerunImages", function(){ 
		})
		this.observer = new MutationObserver(() => {
			runImg();
		  __this.setupBlocks(); 
		  __this.initMode();
		});
		this.observer.observe(this.container, {
		  subtree: true,
		  childList: true,
		});
		
		this.btn=document.querySelectorAll('[img-mode] a');
		this.parent=this.btn[0].parentElement;
		if(!this.parent.hasAttribute('data-active')) return; // stop here if not active
		this.btn.forEach((el)=>{
			el.addEventListener('click', function(e){
				e.preventDefault();
				var mode=e.target.getAttribute('data-mode');
				__this.runMode(mode);
			})
		})
		this.initMode();
	}
	initMode(){
		var __this=this;
		var mode=localStorage.getItem("collectionmode");
		if(typeof(mode)!="undefined") this.mode=mode;
		this.runMode(this.mode);
	}
	setupBlocks(){
		var __this=this;
		this.block=document.querySelectorAll('results-list [ref="slideshow"]:not([data-model-init])');
		this.block.forEach((el)=>{
			el.setAttribute('data-model-init', 1);
			__this.setupSlides(el);
		})
	}
	setupSlides(el){
		var __this=this;
		var slide=el.querySelectorAll('slideshow-slide img');
		var modelFirst=0;
		var wasSet=0;
		var wasSetProduct=0;
		slide.forEach((el, index)=>{
			
			var par=el.closest('slideshow-slide');
			var cont=par.parentElement;
			var alt=el.getAttribute('alt').toLowerCase();;
			if(alt.indexOf(this.term)>-1){
				
				cont.setAttribute('data-model', '');
				par.setAttribute('data-mode', 'model');
				if(!wasSet) par.setAttribute('data-priority', 1)
				wasSet=1;
				if(!index) {
					modelFirst=1;
				}
				
			}else if(alt.indexOf(this.altTerm)>-1){
				
				cont.setAttribute('data-product', '');
				par.setAttribute('data-mode', 'product');
				if(!wasSetProduct) par.setAttribute('data-priority', 1);
				wasSetProduct=1;
			}
		})
	}
	setupBlock(el) {
		var slide=el.closest('slideshow-slide');
		slide.setAttribute('data-model-img', 1);
		
	}
	runMode(mode){
		localStorage.setItem("collectionmode", mode);
		this.mode=mode;
		this.btn.forEach((el)=>{
			if(el.getAttribute('data-mode')==mode) el.classList.add('active');
			else el.classList.remove('active');
		})
		this.container.setAttribute('data-mode', mode);
	}
}

class ThumbNav {
	
	constructor(el) {
		var __this=this;
		this.el=el;
		this.thumb=this.el.querySelectorAll('.thumbs .product-media');
		this.img=this.el.querySelectorAll('ul .product-media');
		this.arr=[];
		this.thumb.forEach((el, index)=>{
			this.arr.push(new Thumb(el, __this.img[index]));
		})
	}
}

class Thumb {
	
	constructor(thumb, img) {
		var __this=this;
		this.thumb=thumb;
		this.img=img;
		this.pos=[];
		
		this.mode=1;
		this.getMode();
		
		this.getLimits();
		
		this.thumb.addEventListener('click', function(){
			__this.scrollImg();
		})		
		window.addEventListener('resize', (e)=>{
			__this.getLimits();
		})
		window.addEventListener('scroll', (e)=>{
			__this.getLimits();
			__this.checkPos();
		})
		document.addEventListener("rerunImages", function(){ 
			__this.getLimits();
			__this.checkPos();
		})
		if(this.mode){
			this.gallery.addEventListener('scroll', (e)=>{
				__this.getLimits();
				__this.checkPos();
			})
		}
	}
	getMode(){
		var el=document.querySelectorAll('.product-grid--alt');
		this.mode=el.length;
		this.gallery=document.querySelectorAll('media-gallery')[0];
	}
	getLimits(){
		var __this=this;
		var pos=this.img.getBoundingClientRect();
		var off=this.mode ? this.gallery.scrollTop : 0;
		this.pos[0]=pos.top+scroll_top+off;
		this.pos[1]=pos.bottom+scroll_top+off;
		this.half=window.innerHeight / 2;
	}
	checkPos(){
		
		var check=this.mode ? this.gallery.scrollTop + this.half : scroll_mid;
		
		if(check>=this.pos[0] && check<this.pos[1]) {
			this.thumb.classList.add('active');
		}else{
			this.thumb.classList.remove('active');
		}
	}
	scrollImg(){
		var top=this.img.getBoundingClientRect().top+this.gallery.scrollTop+scroll_top;
		this.gallery.scrollTo({
			top: top,
			left: 0,
			behavior: 'smooth'
		});
	}
}

class TabList {
	
	constructor(el) {
		var __this=this;
		this.el=el;
		this.baseTabs=this.el.querySelectorAll('accordion-custom');
		this.tabs=this.el.querySelectorAll('.tablist--header')[0];
		this.content=this.el.querySelectorAll('.tablist--content')[0];
		this.setupTabs();
	}
	setupTabs(){
		var __this=this;
		this.arr=[];
		this.baseTabs.forEach((el)=>{
			var tab=el.querySelectorAll('.details__header')[0];
			var content=el.querySelectorAll('.details-content')[0];
			var a=document.createElement('A');
			var div=document.createElement('DIV');
			a.setAttribute('href', '#');
			__this.arr.push(new TabListItem(a, div, __this.el, __this));
			a.innerHTML=tab.innerHTML;
			div.innerHTML=content.outerHTML;
			__this.tabs.appendChild(a);
			__this.content.appendChild(div)
		})
		__this.arr[0].runClick();
	}
}

class TabListItem {
	
	constructor(el, div, parent, root){
		var __this=this;
		this.root=root;
		this.parent=parent;
		this.el=el;
		this.div=div;
		
		this.el.addEventListener('click', (e)=>{
			e.preventDefault();
			__this.runClick(e);
		})	
	}
	runClick(){
		var __this=this;
		this.parent.querySelectorAll('a').forEach((el)=>{
			el.classList.remove('active')
		})
		this.parent.querySelectorAll('.tablist--content > div').forEach((el)=>{
			if(el!==__this.div) el.classList.remove('active');
		})
		this.parent.querySelectorAll('.tablist--content')[0].style.height=this.div.offsetHeight+'px';
		this.el.classList.add('active');
		this.div.classList.add('active');
	}
}

class DropDown {
	constructor(el){
		var __this=this;
		this.el=el;
		this.rel=null;
		this.getRel();
		if(this.rel!=null) this.setupRel();
	}
	getRel(){
		var __this=this;
		var val=this.el.getAttribute('data-related');
		document.querySelectorAll('.menu-list__link-title').forEach((el)=>{
			var text=el.innerText.toLowerCase();
			if(val==text) __this.rel=el.closest('a');
		})
	}
	setupRel(){
		var __this=this;
		this.timer=null;
		this.dropdown=document.querySelectorAll('.drop--down');
		this.rel.addEventListener('mouseenter', function(e){ __this.startHover() });
		this.el.addEventListener('mouseenter', (e)=>{ __this.startHover() });
		this.rel.addEventListener('mouseleave', (e)=>{ __this.endHover() });
		this.el.addEventListener('mouseleave', (e)=>{ __this.endHover() });
		//this.addCarat();
		document.addEventListener('rerunImages', function(){ __this.addCarat(); });
		
	}
	startHover(e){
		var __this=this;
		clearTimeout(this.timer);
		this.dropdown.forEach((el)=>{
			if(el!==__this.el) el.removeAttribute('data-active');
		})
		this.el.setAttribute('data-active', 1);
	}
	endHover(){
		var __this=this;
		clearTimeout(this.timer);
		this.timer=setTimeout(function(){ __this.el.removeAttribute('data-active'); }, 75);
	}
	addCarat(){
		var __this=this;
		clearTimeout(this.timer);
		this.timer=setTimeout(function(){ __this.carat(); }, 0);
	}
	carat(){
		var svg=this.rel.querySelectorAll('svg');
		if(svg.length) return
		var div=document.createElement('DIV');
		div.classList.add('svg-wrapper');
		div.classList.add('svg-wrapper--small');
		div.classList.add('svg-wrapper--animation');
		div.innerHTML=iconCarat();
		this.rel.closest('a').append(div);
		div.offsetHeight;
		div.classList.remove('svg-wrapper--animation');
	}
}

class Filter {
	constructor(){
		var __this=this;
		this.btn=document.querySelectorAll('[href*="/filter"], [class*="facets-drawer__close"][data-type="filter"]');
		this.btn.forEach((el)=>{
			el.addEventListener('click', function(e){
				e.preventDefault();
				if(!document.body.hasAttribute('data-filter')) document.body.setAttribute('data-filter', 1);
				else document.body.removeAttribute('data-filter');
			})
		})
		this.btn=document.querySelectorAll('[href*="/sort"], [class*="facets-drawer__close"][data-type="sort"]');
		this.btn.forEach((el)=>{
			el.addEventListener('click', function(e){
				e.preventDefault();
				if(!document.body.hasAttribute('data-sort')) document.body.setAttribute('data-sort', 1);
				else document.body.removeAttribute('data-sort');
			})
		})
		var sortModal=document.querySelector('.filter--modal__sorting');
		if(sortModal){
			sortModal.addEventListener('click', function(e){
				if(!(e.target instanceof Element)) return;
				var option=e.target.closest('.sorting-filter__option');
				if(option){
					var input=option.querySelector('input[name="sort_by"]');
					if(input instanceof HTMLInputElement){
						var url=new URL(window.location.href);
						url.searchParams.set('sort_by', input.value);
						url.searchParams.delete('page');
						document.body.removeAttribute('data-sort');
						window.location.href=url.toString();
					}
				}
			});
		}
	}
}

class Visibility {
	
	constructor(){
		var __this=this;
		
		var __this=this;
		this.elArr=[];
		this.init();
		window.addEventListener('resize', (e)=>{
			if(__this.elArr.length) __this.initPosition();
		})
		window.addEventListener('scroll', (e)=>{
			if(__this.elArr.length) __this.runScroll();
		})
	}
	init(){
		var __this=this;
		document.querySelectorAll('.data-visibility').forEach((el)=>{
			__this.elArr.push(el);
		})
		if(__this.elArr.length) this.initPosition();
	}
	initPosition(){
		this.elArr.forEach((el)=>{
			var rect=el.getBoundingClientRect();
			el.start=rect.top+scroll_top;
			el.end=rect.bottom+scroll_top;
		})
		this.runScroll();
	}
	runScroll(){
		var __this=this;
		this.elArr.forEach((el)=>{
			if(scroll_mid>=el.start&&scroll_top<el.end){
				el.setAttribute('data-init', 1);
				el.setAttribute('data-visibility', 1);
			}
			else {
				el.removeAttribute('data-visibility');
			}
		})
	}
}

class Dark {
	constructor(){
		var __this=this;
		this.elArr=[];
		this.init();
		window.addEventListener('resize', (e)=>{
			if(__this.elArr.length) __this.initPosition();
		})
		window.addEventListener('scroll', (e)=>{
			if(__this.elArr.length) __this.runScroll();
		})
	}
	init(){
		var __this=this;
		document.querySelectorAll('[data-dark]').forEach((el)=>{
			var par=el.closest('.shopify-section');
			__this.elArr.push(par);
		})
		if(__this.elArr.length) this.initPosition();
	}
	initPosition(){
		console.log('initialise position');
		this.elArr.forEach((el)=>{
			var rect=el.getBoundingClientRect();
			el.start=rect.top+scroll_top;
			el.end=rect.bottom+scroll_top;
		})
		this.runScroll();
	}
	runScroll(){
		var isDark=0;
		this.elArr.forEach((el)=>{
			if(scroll_top>=el.start&&scroll_top<el.end){
				isDark=1;
			}
		})
		if(isDark) body.setAttribute('data-dark', 1);
		else body.removeAttribute('data-dark');
	}
}

class CarouselInstagram{
  
  constructor(el){
	
	var __this=this;
	this.el=el;
	this.id='#insta-feed';
	console.log(this.el.outerHTML);

	this.itemClass='.instafeed-new-layout-item';
	this.attempts=10;
	this.wait=1500;
	this.distance=.5;
	this.interval=null;
	this.imgClass='.fs-entry-container';
	this.currPos=0;
	this.prevScroll=scroll_top;
	
	this.direction=0;
	
	this.testAvailable();
  }

  createCarousel(){
	var __this=this;
	
	this.base=document.createElement('div');
	this.base.classList.add('carousel-ig-container');
	this.base.innerHTML='<div class="carousel-ig"><div class="carousel-ig-box"></div><div class="carousel-ig-box"></div></div>';
	this.boxClass='.carousel-ig--box';
	this.attach=this.el.closest('.wrapper');
	this.attach.parentNode.insertBefore(this.base, this.attach);
	this.cont=this.base.querySelectorAll('.carousel-ig')[0];
	this.runSetup();
  }

  testAvailable(){
	var __this=this;
	this.img=this.el.querySelectorAll(this.itemClass);
	if(this.img.length){
	  this.createCarousel();
	}else{
	  this.setSetTimeout();
	}
  }
  
  setSetTimeout(){
	var __this=this;
	setTimeout(function(){ __this.testAvailable(); }, this.wait);
  }
  
  runSetup(){
	
	var __this=this;
	this.box=this.cont.querySelectorAll('.carousel-ig-box');
	this.box.forEach((parentEl, index)=>{
	  __this.img.forEach(function(el, index){
		var div=document.createElement('DIV');
		div.classList.add('carousel-ig--item');
		div.innerHTML=el.outerHTML;
		var img=div.querySelectorAll('.instafeed-lazy-image')[0];
		var src=img.getAttribute('data-instafeed-src');
		img.setAttribute('src', src);
		parentEl.appendChild(div);
		div.rel=el;
	  });  
	})

	if(this.direction) this.currPos=-1*this.currPos;
	
	window.addEventListener('scroll', (e)=>{
	  __this.testVisible();
	});
	window.addEventListener('resize', (e)=>{
	  __this.runPosition();
	});
		
	this.testVisible()
	this.runPosition();
	
  }
  
  testVisible(){
	var __this=this;

	if(__this.cont.hasAttribute('data-visible')||1==1){
	  if(__this.interval==null) this.interval=setInterval( function(){ __this.runSection() }, 36 );
	} else {
	  if(__this.interval!=null){
		clearInterval(__this.interval);
		__this.interval=null;
	  }
	}
  }
  
  runPosition(){
	var __this=this;
	
	var intElements=this.el.querySelectorAll('.carousel-ig--item[data-src-complete]');
	if(!intElements.length) return;
	var intEl=intElements[intElements.length-1];
	this.boxClone=this.el.querySelectorAll('.carousel-ig--box')[1];
	intElements.forEach((el)=>{
		var pos=el.getBoundingClientRect();
		el.setAttribute('data-right', pos.right);
	})
	this.offset=intEl.getBoundingClientRect().right-intEl.parentElement.getBoundingClientRect().left;

	if(this.direction){
	  this.boxClone.style.left=-this.offset+'px';
	}else{
	  this.boxClone.style.left=this.offset+'px';
	}
  }
  
  runSection(){
	var __this=this;
	
	var currScroll=scroll_top;
	var extra=Math.abs(currScroll-this.prevScroll)/12;
	var newPos=this.currPos-extra-this.distance;
	
	var overflow=newPos+this.offset;
	
	newPos=overflow<0 ? overflow:newPos;
	newPos=newPos.toFixed(3);
	
	if(this.direction){
	  var intPos=-newPos;
	  this.cont.style.transform='translate('+intPos+'px, 0)';  
	}else{
	  this.cont.style.transform='translate('+newPos+'px, 0)';
	}
	
	this.prevScroll=currScroll;
	this.currPos=newPos;
	
  }
}

function iconCarat (){
	return '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve"><style type="text/css">.st0{fill:none;stroke:#000000;stroke-width:2.4367;stroke-miterlimit:10;}</style><polyline class="st0" points="4.9,19.7 30.2,45 55.1,19.7 "/></svg>';
}

/**
 * Maku + Unicorn Cart integration
 *
 * Unicorn Cart's "Auto open cart" toggle must be OFF in the Unicorn Cart app settings.
 * This script replaces that behaviour by opening the cart manually via window.unicornOpenCart().
 *
 * - Regular add-to-cart: opens Unicorn Cart after a successful /cart/add request.
 * - Try with Mirra add-to-cart: suppresses auto-open while the Mirra modal is shown, then
 *   opens Unicorn Cart when the customer closes the modal via mirraModalClose() (X or Continue).
 *   Backdrop dismiss (mirraModalOverlayClick) is not hooked.
 *
 * - Checkout button + Checkout+ primary button + cart summary: show "due today"
 *   instead of full cart total (non–Try with Mirra line totals only).
 *   Debug: window.__mirraScanUnicornMoneyTexts() finds elements showing the full total.
 *   Set MIRRA_UNICORN_DEBUG to false to silence logs.
 *
 * Install: paste into the theme's global JS (e.g. theme.js / global.js), after Unicorn Cart loads.
 */
(function () {
  var MIRRA_UNICORN_DEBUG = false;
  var LOG_PREFIX = "[Mirra Unicorn]";

  function mirraLog() {
    if (!MIRRA_UNICORN_DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG_PREFIX);
    console.log.apply(console, args);
  }

  function mirraWarn() {
    if (!MIRRA_UNICORN_DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG_PREFIX);
    console.warn.apply(console, args);
  }
  var OPEN_DELAY_MS = 50;
  var lastOpenAt = 0;

  window.__mirraTryAddPendingOpen = false;
  var expectDueTodayOverrideUntil = 0;
  var cartFetchPromise = null;
  var dueTodayRetryTimer = null;
  var lastCartSnapshot = null;
  var checkoutButtonWatchdogTimer = null;

  function openUnicornCart(options) {
    options = options || {};
    var skipDebounce = options.skipDebounce;

    if (!skipDebounce) {
      var now = Date.now();
      if (now - lastOpenAt < 500) return;
      lastOpenAt = now;
    }

    if (typeof window.unicornOpenCart !== "function") return;

    setTimeout(function () {
      try {
        window.unicornOpenCart();
      } catch (e) {}
    }, skipDebounce ? 0 : OPEN_DELAY_MS);
  }

  function isCartAddUrl(url) {
    try {
      var u = typeof url === "string" ? url : (url && url.url) || "";
      return /\/cart\/add(\.js)?(\?|$)/.test(u);
    } catch (e) {
      return false;
    }
  }

  function isCartMutationUrl(url) {
    try {
      var u = typeof url === "string" ? url : (url && url.url) || "";
      return /\/cart\/(update|change)(\.js)?(\?|$)/.test(u);
    } catch (e) {
      return false;
    }
  }

  function looksLikeTryAdd(body) {
    if (!body) return false;

    if (typeof body === "string") {
      try {
        body = JSON.parse(body);
      } catch (e) {}
    }

    try {
      if (body instanceof FormData) {
        return body.has("selling_plan") || body.has("items[0][selling_plan]");
      }
      var items = body.items || (body.item ? [body.item] : null);
      if (Array.isArray(items)) {
        return items.some(function (it) {
          return (
            !!it.selling_plan ||
            !!it.selling_plan_id ||
            (it.properties && (it.properties._mirra || it.properties.mirra))
          );
        });
      }
      return (
        !!body.selling_plan ||
        !!body.selling_plan_id ||
        (body.properties && (body.properties._mirra || body.properties.mirra))
      );
    } catch (e) {
      return false;
    }
  }

  function markExpectDueTodayOverride() {
    expectDueTodayOverrideUntil = Date.now() + 15000;
  }

  function handleCartAddSuccess(body) {
    if (looksLikeTryAdd(body)) {
      window.__mirraTryAddPendingOpen = true;
      markExpectDueTodayOverride();
      refreshDueTodayUntilReady("cartAdd", 0);
    } else {
      openUnicornCart();
      if (cachedDueToday) {
        refreshDueTodayUntilReady("cartAdd", 0);
      }
    }
  }

  function beginTryAddDueTodayRefresh(source) {
    markExpectDueTodayOverride();
    refreshDueTodayUntilReady(source, 0);
    startCheckoutButtonWatchdog(source);
  }

  function isCartApiUrl(url) {
    try {
      var u = typeof url === "string" ? url : (url && url.url) || "";
      return /\/cart(\.js|\/add\.js|\/update\.js|\/change\.js)?(\?|$)/.test(u);
    } catch (e) {
      return false;
    }
  }

  function normalizeCartFromApiPayload(data) {
    if (!data || !Array.isArray(data.items)) return null;
    return data;
  }

  function mergeLineItemIntoCart(cart, item) {
    var items = (cart.items || []).slice();
    var idx = -1;

    for (var i = 0; i < items.length; i++) {
      if (items[i].key === item.key) {
        idx = i;
        break;
      }
    }

    if (idx >= 0) {
      items[idx] = item;
    } else {
      items.push(item);
    }

    var total = 0;
    var count = 0;
    items.forEach(function (it) {
      total +=
        it.final_line_price != null ? it.final_line_price : it.line_price || 0;
      count += it.quantity || 0;
    });

    return {
      currency: cart.currency || item.currency,
      items: items,
      item_count: count,
      total_price: total,
    };
  }

  function applyOptimisticCacheFromAddItem(item, body, source) {
    if (!item || item.variant_id == null) return;
    if (!looksLikeTryAdd(body) && !isTryWithMirraLine(item)) return;

    var base =
      lastCartSnapshot || { items: [], total_price: 0, currency: "AUD" };
    var merged = mergeLineItemIntoCart(base, item);

    if (!cartNeedsDueTodayOverride(merged)) {
      return;
    }

    mirraLog("Optimistic due-today cache from add response", {
      source: source,
      dueTodayCents: getDueTodayCents(merged, false).dueTodayCents,
    });

    setCachedDueToday(merged, source + ":optimistic");
    patchWhenCheckoutButtonsAppear(source + ":optimistic", 45);
    startCheckoutButtonWatchdog(source + ":optimistic");
  }

  function processCartApiResponse(res, url, source) {
    if (!res || !res.ok || !isCartApiUrl(url)) {
      return Promise.resolve();
    }

    return res
      .clone()
      .json()
      .then(function (data) {
        var cart = normalizeCartFromApiPayload(data);
        if (cart) {
          setCachedDueToday(cart, source);
        }
      })
      .catch(function () {});
  }

  function prefetchCartCache(source) {
    refreshDueTodayUntilReady(source, 0);
  }

  function fetchCartJson(source) {
    var chained = cartFetchPromise
      ? cartFetchPromise.then(function (result) {
          return result;
        })
      : null;

    if (chained) {
      return chained;
    }

    cartFetchPromise = fetch("/cart.js", { mirraInternalCartFetch: true })
      .then(function (r) {
        if (!r.ok) throw new Error("cart.js returned " + r.status);
        return r.json();
      })
      .then(function (cart) {
        var cacheReady = setCachedDueToday(cart, source);
        return { cart: cart, cacheReady: cacheReady };
      })
      .finally(function () {
        cartFetchPromise = null;
      });

    return cartFetchPromise;
  }

  function refreshDueTodayUntilReady(source, attempt) {
    attempt = attempt || 0;

    if (cachedDueToday) {
      patchWhenCheckoutButtonsAppear(source, 30);
      return;
    }

    if (Date.now() >= expectDueTodayOverrideUntil) {
      return;
    }

    if (attempt >= 20) {
      return;
    }

    var delay = attempt === 0 ? 0 : Math.min(30 + attempt * 35, 150);

    clearTimeout(dueTodayRetryTimer);
    dueTodayRetryTimer = setTimeout(function () {
      fetchCartJson(source + ":retry:" + attempt)
        .then(function (result) {
          if (result.cacheReady) {
            patchWhenCheckoutButtonsAppear(source, 30);
            return;
          }
          refreshDueTodayUntilReady(source, attempt + 1);
        })
        .catch(function () {
          refreshDueTodayUntilReady(source, attempt + 1);
        });
    }, delay);
  }

  function patchWhenCheckoutButtonsAppear(source, framesLeft) {
    if (cachedDueToday && applyDueTodayFromCache(source)) {
      return;
    }

    if (framesLeft <= 0) {
      if (!cachedDueToday && Date.now() < expectDueTodayOverrideUntil) {
        refreshDueTodayUntilReady(source + ":fallback", 0);
      }
      return;
    }

    requestAnimationFrame(function () {
      patchWhenCheckoutButtonsAppear(source, framesLeft - 1);
    });
  }

  function scheduleDueTodayRefresh(source) {
    applyDueTodayFromCache(source + ":sync");
    requestAnimationFrame(function () {
      applyDueTodayFromCache(source + ":raf1");
    });
  }

  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = input;
      var body = init && init.body;
      var isInternalCartFetch = !!(init && init.mirraInternalCartFetch);
      var isTryAddRequest =
        !isInternalCartFetch && isCartAddUrl(url) && looksLikeTryAdd(body);

      if (isTryAddRequest) {
        beginTryAddDueTodayRefresh("add:pending");
      }

      return _fetch.apply(this, arguments).then(function (res) {
        var process = isInternalCartFetch
          ? Promise.resolve()
          : processCartApiResponse(
              res,
              url,
              "fetch:" + (typeof url === "string" ? url : "cart")
            );

        return process.then(function () {
          if (isCartAddUrl(url) && res && res.ok && !isInternalCartFetch) {
            var addDone = looksLikeTryAdd(body)
              ? res
                  .clone()
                  .json()
                  .then(function (item) {
                    applyOptimisticCacheFromAddItem(item, body, "add:response");
                  })
                  .catch(function () {})
              : Promise.resolve();

            return addDone.then(function () {
              handleCartAddSuccess(body);
              return res;
            });
          } else if (
            isCartMutationUrl(url) &&
            res &&
            res.ok &&
            !isInternalCartFetch
          ) {
            scheduleDueTodayRefresh("cartApi:fetch");
          }
          return res;
        });
      });
    };
  }

  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__mirra_url = url;
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this;
    var isTryAddRequest = isCartAddUrl(xhr.__mirra_url) && looksLikeTryAdd(body);

    if (isTryAddRequest) {
      beginTryAddDueTodayRefresh("add:pending:xhr");
    }

    function onLoad() {
      try {
        if (
          isCartAddUrl(xhr.__mirra_url) &&
          xhr.status >= 200 &&
          xhr.status < 300
        ) {
          if (looksLikeTryAdd(body)) {
            try {
              var addItem = JSON.parse(xhr.responseText);
              applyOptimisticCacheFromAddItem(
                addItem,
                body,
                "add:response:xhr"
              );
            } catch (e) {}
          }
          handleCartAddSuccess(body);
        }

        if (
          isCartMutationUrl(xhr.__mirra_url) &&
          xhr.status >= 200 &&
          xhr.status < 300
        ) {
          try {
            var data = JSON.parse(xhr.responseText);
            var cart = normalizeCartFromApiPayload(data);
            if (cart) {
              setCachedDueToday(cart, "xhr:" + xhr.__mirra_url);
            }
          } catch (e) {}

          scheduleDueTodayRefresh("cartApi:xhr");
        }
      } catch (e) {}
    }
    xhr.addEventListener("load", onLoad);
    return _send.apply(this, arguments);
  };

  window.addEventListener("tryWithMirraAddToCartModalOpen", function () {
    window.__mirraTryAddPendingOpen = true;
    beginTryAddDueTodayRefresh("modalOpen");
  });

  function patchMirraModalClose() {
    if (typeof window.mirraModalClose !== "function") return;
    if (window.mirraModalClose.__mirra_patched) return;

    var original = window.mirraModalClose;
    function wrappedMirraModalClose() {
      var result = original.apply(this, arguments);

      if (window.__mirraTryAddPendingOpen) {
        window.__mirraTryAddPendingOpen = false;
        if (cachedDueToday) {
          applyDueTodayFromCache("modalClose:preOpen");
        }
        openUnicornCart({ skipDebounce: true });
        refreshDueTodayUntilReady("modalClose", 0);
      }

      return result;
    }
    wrappedMirraModalClose.__mirra_patched = true;
    window.mirraModalClose = wrappedMirraModalClose;
  }

  patchMirraModalClose();
  var tries = 0;
  var patchInterval = setInterval(function () {
    patchMirraModalClose();
    tries++;
    if (
      tries > 40 ||
      (window.mirraModalClose && window.mirraModalClose.__mirra_patched)
    ) {
      clearInterval(patchInterval);
    }
  }, 250);

  // --- Unicorn / Checkout+ due-today display overrides ---
  var CHECKOUT_TEXT_SELECTOR = ".unicorn_cart_checkout_button_text";
  var CHECKOUT_PLUS_BUTTON_SELECTORS =
    '#primary-button, button[data-original-text*="Checkout+"]';
  var TRY_PLAN_NAME = "Try with Mirra";
  // Checkout+ protection upsell appears in cart.js but is excluded from due-today by default
  var EXCLUDE_CHECKOUT_PLUS_FROM_DUE_TODAY = true;
  var CHECKOUT_PLUS_TITLE_PATTERN = /unlock free returns|shipping protection|checkout\+/i;
  var lastAppliedCheckoutText = null;
  var lastAppliedCheckoutPlusText = null;
  var cachedDueToday = null;
  var checkoutUpdateInFlight = false;
  var mirraApplyingDueToday = false;

  function isTryWithMirraLine(item) {
    var planName =
      item.selling_plan_allocation &&
      item.selling_plan_allocation.selling_plan &&
      item.selling_plan_allocation.selling_plan.name;
    return planName === TRY_PLAN_NAME;
  }

  function isCheckoutPlusUpsell(item) {
    return CHECKOUT_PLUS_TITLE_PATTERN.test(item.title || "");
  }

  function formatDueToday(cents, currency) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(
        cents,
        window.theme && window.theme.moneyFormat
      );
    }
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency || "AUD",
    }).format(cents / 100);
  }

  function getMoneyTextVariants(cents, currency) {
    var formatted = formatDueToday(cents, currency);
    var variants = [formatted, formatted + " " + currency];
    if (formatted.indexOf(".00") !== -1) {
      variants.push(formatted.replace(".00", ""));
    }
    return variants;
  }

  function textMatchesMoneyAmount(text, cents, currency) {
    if (!text) return false;
    var trimmed = text.trim();
    return getMoneyTextVariants(cents, currency).some(function (variant) {
      return trimmed === variant || trimmed.indexOf(variant) !== -1;
    });
  }

  function findUnicornCartRoots() {
    var roots = [];
    var seen = new Set();

    function addRoot(el) {
      if (!el || seen.has(el)) return;
      seen.add(el);
      roots.push(el);
    }

    document
      .querySelectorAll(
        '.unicorn_cart_checkout, [class*="items_cart_table"], [class*="unicorn_cart"], checkout-plus'
      )
      .forEach(function (el) {
        addRoot(el.closest('[class*="unicorn"]') || el);
      });

    if (roots.length === 0) {
      addRoot(document.body);
    }

    return roots;
  }

  function queryAllIncludingShadowRoots(selector, roots) {
    var results = [];
    var seen = new Set();

    function add(el) {
      if (!el || seen.has(el)) return;
      seen.add(el);
      results.push(el);
    }

    (roots || [document]).forEach(function (root) {
      if (root.querySelectorAll) {
        root.querySelectorAll(selector).forEach(add);
      }
      if (root.shadowRoot) {
        root.shadowRoot.querySelectorAll(selector).forEach(add);
      }
    });

    document.querySelectorAll("checkout-plus, [class*='unicorn']").forEach(function (host) {
      if (host.shadowRoot) {
        host.shadowRoot.querySelectorAll(selector).forEach(add);
      }
    });

    return results;
  }

  function isInsideLineItemPrice(el) {
    return !!(
      el.closest(".unicorn_cart_item") &&
      el.closest(".unicorn_cart_cell_amounts, .items_amounts__Bp2GJ")
    );
  }

  function isCheckoutButtonTextEl(el) {
    return el.matches && el.matches(CHECKOUT_TEXT_SELECTOR);
  }

  function isCheckoutPlusPrimaryButton(el) {
    if (!el || el.tagName !== "BUTTON") return false;
    if (el.id === "primary-button") return true;
    var originalText = el.getAttribute("data-original-text") || "";
    return originalText.indexOf("Checkout+") !== -1;
  }

  function buildCheckoutPlusButtonText(formatted) {
    return "Checkout+ | " + formatted;
  }

  function getDueTodayCents(cart, verbose) {
    var breakdown = {
      try_excluded_cents: 0,
      checkout_plus_excluded_cents: 0,
      included_cents: 0,
      lines: [],
    };

    var dueTodayCents = cart.items.reduce(function (sum, item) {
      var isTry = isTryWithMirraLine(item);
      var isCheckoutPlus =
        EXCLUDE_CHECKOUT_PLUS_FROM_DUE_TODAY && isCheckoutPlusUpsell(item);
      var counts = !isTry && !isCheckoutPlus;
      var lineInfo = {
        title: item.title,
        quantity: item.quantity,
        final_line_price: item.final_line_price,
        selling_plan:
          (item.selling_plan_allocation &&
            item.selling_plan_allocation.selling_plan &&
            item.selling_plan_allocation.selling_plan.name) ||
          null,
        excluded_reason: isTry
          ? "try_with_mirra"
          : isCheckoutPlus
            ? "checkout_plus_upsell"
            : null,
        counts_toward_due_today: counts,
      };

      breakdown.lines.push(lineInfo);
      if (verbose) {
        mirraLog("Cart line:", lineInfo);
      }

      if (isTry) {
        breakdown.try_excluded_cents += item.final_line_price;
        return sum;
      }
      if (isCheckoutPlus) {
        breakdown.checkout_plus_excluded_cents += item.final_line_price;
        return sum;
      }

      breakdown.included_cents += item.final_line_price;
      return sum + item.final_line_price;
    }, 0);

    breakdown.due_today_cents = dueTodayCents;
    return { dueTodayCents: dueTodayCents, breakdown: breakdown };
  }

  function cartNeedsDueTodayOverride(cart) {
    return getDueTodayCents(cart, false).breakdown.try_excluded_cents > 0;
  }

  function setCachedDueToday(cart, source) {
    if (!cartNeedsDueTodayOverride(cart)) {
      if (Date.now() < expectDueTodayOverrideUntil) {
        mirraLog("Ignoring stale cart response while try add pending", {
          source: source,
        });
        return false;
      }

      cachedDueToday = null;
      lastAppliedCheckoutText = null;
      lastAppliedCheckoutPlusText = null;
      lastCartSnapshot = cart;
      return true;
    }

    expectDueTodayOverrideUntil = 0;

    var result = getDueTodayCents(cart, false);
    var currency =
      cart.currency ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      "AUD";
    var formatted = formatDueToday(result.dueTodayCents, currency);

    cachedDueToday = {
      cart: cart,
      dueTodayCents: result.dueTodayCents,
      breakdown: result.breakdown,
      formatted: formatted,
      currency: currency,
      unicornText: "Checkout • " + formatted + " " + currency,
      checkoutPlusText: buildCheckoutPlusButtonText(formatted),
    };

    applyDueTodayFromCache(source);
    lastCartSnapshot = cart;
    return true;
  }

  function startCheckoutButtonWatchdog(source) {
    clearInterval(checkoutButtonWatchdogTimer);
    var started = Date.now();

    checkoutButtonWatchdogTimer = setInterval(function () {
      if (Date.now() - started > 15000) {
        clearInterval(checkoutButtonWatchdogTimer);
        checkoutButtonWatchdogTimer = null;
        return;
      }

      observeCheckoutPlusShadowRoots();

      if (!cachedDueToday) {
        return;
      }

      if (checkoutButtonsNeedPatch()) {
        applyDueTodayFromCache(source + ":watchdog");
      } else if (Date.now() >= expectDueTodayOverrideUntil) {
        clearInterval(checkoutButtonWatchdogTimer);
        checkoutButtonWatchdogTimer = null;
      }
    }, 75);
  }

  function applyDueTodayFromCache(source) {
    if (!cachedDueToday || mirraApplyingDueToday) return false;

    mirraApplyingDueToday = true;
    try {
      var checkoutEls = findCheckoutButtonTextEls();
      var checkoutPlusEls = findCheckoutPlusButtonEls();

      applyCheckoutButtonText(checkoutEls, cachedDueToday.unicornText, source);
      applyCheckoutPlusButtonText(
        checkoutPlusEls,
        cachedDueToday.formatted,
        source
      );
      updateCartSummaryTotals(
        cachedDueToday.cart,
        cachedDueToday.dueTodayCents,
        cachedDueToday.formatted,
        source
      );

      return checkoutEls.length > 0 || checkoutPlusEls.length > 0;
    } finally {
      mirraApplyingDueToday = false;
    }
  }

  function checkoutButtonsNeedPatch() {
    if (!cachedDueToday) return false;

    var checkoutEls = findCheckoutButtonTextEls();
    var checkoutPlusEls = findCheckoutPlusButtonEls();

    var unicornNeedsPatch = checkoutEls.some(function (el) {
      return el.textContent !== cachedDueToday.unicornText;
    });

    var checkoutPlusNeedsPatch = checkoutPlusEls.some(function (el) {
      return (
        el.textContent !== cachedDueToday.checkoutPlusText ||
        el.getAttribute("data-original-text") !== cachedDueToday.checkoutPlusText
      );
    });

    return unicornNeedsPatch || checkoutPlusNeedsPatch;
  }

  function findCheckoutButtonTextEls() {
    return queryAllIncludingShadowRoots(
      CHECKOUT_TEXT_SELECTOR,
      findUnicornCartRoots()
    );
  }

  function findCheckoutPlusButtonEls() {
    return queryAllIncludingShadowRoots(
      CHECKOUT_PLUS_BUTTON_SELECTORS,
      findUnicornCartRoots()
    ).filter(isCheckoutPlusPrimaryButton);
  }

  function applyCheckoutButtonText(els, newText, source) {
    if (!els.length) return;

    els.forEach(function (el) {
      if (el.textContent === newText) return;
      var previousText = el.textContent;
      el.textContent = newText;
      mirraLog("Unicorn checkout button text updated", {
        source: source,
        from: previousText,
        to: newText,
      });
    });

    lastAppliedCheckoutText = newText;
  }

  function applyCheckoutPlusButtonText(els, formatted, source) {
    if (!els.length) return;

    var newText = buildCheckoutPlusButtonText(formatted);

    els.forEach(function (el) {
      if (
        el.textContent === newText &&
        el.getAttribute("data-original-text") === newText
      ) {
        return;
      }

      var previousText = el.textContent;
      el.textContent = newText;
      el.setAttribute("data-original-text", newText);
      mirraLog("Checkout+ primary button updated", {
        source: source,
        from: previousText,
        to: newText,
      });
    });

    lastAppliedCheckoutPlusText = newText;
  }

  function updateCartSummaryTotals(cart, dueTodayCents, dueFormatted, source) {
    if (dueTodayCents === cart.total_price) return;

    var roots = findUnicornCartRoots();
    var summarySelectors = [
      '[class*="summary"] [class*="total"]',
      '[class*="subtotal"]',
      '[class*="cart_total"]',
      '[class*="totals_"]',
      '[class*="checkout_total"]',
      '[class*="amount_due"]',
    ];

    summarySelectors.forEach(function (selector) {
      queryAllIncludingShadowRoots(selector, roots).forEach(function (el) {
        if (isInsideLineItemPrice(el) || isCheckoutButtonTextEl(el)) return;

        var text = (el.textContent || "").trim();
        if (!textMatchesMoneyAmount(text, cart.total_price, cart.currency)) {
          return;
        }

        var previousText = text;
        el.textContent = dueFormatted;
        mirraLog("Cart summary total updated", {
          source: source,
          selector: selector,
          className: el.className,
          from: previousText,
          to: dueFormatted,
        });
      });
    });
  }

  function updateUnicornDueTodayDisplays(source) {
    source = source || "unknown";

    if (applyDueTodayFromCache(source + ":cache-first")) {
      mirraLog("Applied due-today from cache", { source: source });
      return;
    }

    if (checkoutUpdateInFlight) {
      return;
    }

    checkoutUpdateInFlight = true;

    fetchCartJson(source + ":confirm")
      .catch(function (err) {
        mirraWarn("Failed to refresh due-today displays", {
          source: source,
          error: err && err.message,
        });
      })
      .finally(function () {
        checkoutUpdateInFlight = false;
      });
  }

  window.__mirraUpdateUnicornCheckoutButtonText = updateUnicornDueTodayDisplays;
  window.__mirraScanUnicornMoneyTexts = function () {
    fetch("/cart.js")
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var roots = findUnicornCartRoots();
        var hits = [];
        roots.forEach(function (root) {
          root.querySelectorAll("*").forEach(function (el) {
            if (el.children.length > 0) return;
            var text = (el.textContent || "").trim();
            if (
              textMatchesMoneyAmount(text, cart.total_price, cart.currency) &&
              !isInsideLineItemPrice(el)
            ) {
              hits.push({
                text: text,
                className: el.className,
                tag: el.tagName,
                id: el.id,
                isUnicornCheckoutButton: isCheckoutButtonTextEl(el),
                isCheckoutPlusButton: isCheckoutPlusPrimaryButton(el),
              });
            }
          });
        });
        console.log(LOG_PREFIX, "Money text scan for full cart total", {
          cart_total_price: cart.total_price,
          formatted: formatDueToday(cart.total_price, cart.currency),
          hits: hits,
        });
        return hits;
      });
  };

  function observeCheckoutPlusShadowRoots() {
    document.querySelectorAll("checkout-plus").forEach(function (host) {
      if (host.__mirraCheckoutPlusObserved || !host.shadowRoot) return;
      host.__mirraCheckoutPlusObserved = true;

      new MutationObserver(function () {
        if (cachedDueToday && checkoutButtonsNeedPatch()) {
          applyDueTodayFromCache("checkoutPlus:shadow");
        } else if (
          !cachedDueToday &&
          Date.now() < expectDueTodayOverrideUntil
        ) {
          refreshDueTodayUntilReady("checkoutPlus:shadow", 0);
        }
      }).observe(host.shadowRoot, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    });
  }

  prefetchCartCache("init");
  observeCheckoutPlusShadowRoots();

  mirraLog("Integration loaded", {
    unicornOpenCart: typeof window.unicornOpenCart,
    mirraModalClose: typeof window.mirraModalClose,
    checkoutSelector: CHECKOUT_TEXT_SELECTOR,
  });

  ["cart:updated", "tryWithMirraCartValidation"].forEach(function (evt) {
    window.addEventListener(evt, function () {
      if (cachedDueToday) {
        scheduleDueTodayRefresh("event:" + evt);
      } else if (Date.now() < expectDueTodayOverrideUntil) {
        refreshDueTodayUntilReady("event:" + evt, 0);
      }
    });
  });

  var checkoutObserver = new MutationObserver(function () {
    observeCheckoutPlusShadowRoots();

    if (cachedDueToday && checkoutButtonsNeedPatch()) {
      applyDueTodayFromCache("mutation:instant");
      return;
    }

    if (
      !cachedDueToday &&
      Date.now() < expectDueTodayOverrideUntil &&
      (findCheckoutPlusButtonEls().length || findCheckoutButtonTextEls().length)
    ) {
      refreshDueTodayUntilReady("mutation:awaiting-cache", 0);
    }
  });
  checkoutObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Re-run after cart opens / items added
  var originalOpenUnicornCart = openUnicornCart;
  openUnicornCart = function (options) {
    if (cachedDueToday) {
      applyDueTodayFromCache("openUnicornCart:preOpen");
    }
    originalOpenUnicornCart(options);
    refreshDueTodayUntilReady("openUnicornCart", 0);
    patchWhenCheckoutButtonsAppear("openUnicornCart", 45);
  };
})();
